import React, { useCallback, useEffect, useState, useRef } from "react";
import styles from "./AddDealershipForm.module.css";
import useApiFetcher from "../../hooks/useApiFetcher";
import Table from "./Table";
import { debounce } from "../Avatar/Utility";
import Multiselect from "../../shared-components/Multiselect/Multiselect";
import LoaderSpiner from "../LoaderSpiner"
import HarryCasual from "../../Images/AvatarImages/harry casual 1.png";
import HarryBusiness from "../../Images/AvatarImages/harry bussiness 2.png";
import HarryYouthful from "../../Images/AvatarImages/harry youthfull 3.png";
import JeffBusiness from "../../Images/AvatarImages/jeff business 4.png";
import JeffFormal from "../../Images/AvatarImages/jeff formal 5.png";
import LisaCasualSitting from "../../Images/AvatarImages/lisa 6.png";
import LoriCasual from "../../Images/AvatarImages/lori casual 7.png";
import LoriGraceful from "../../Images/AvatarImages/lori graceful 8.png";
import LoriFormal from "../../Images/AvatarImages/lori formal 9.png";
import MegFormal from "../../Images/AvatarImages/mag formal 10.png";
import MegCasual from "../../Images/AvatarImages/mag casual 11.png";
import Swal from "sweetalert2";


const columns = [
  { _id: 1, name: "No", field: "_id" },
  { _id: 2, name: "Dealership Name", field: "dealershipName" },
  
  { _id: 2, name: "Avtar Action", field: "avatraction" },
  { _id: 2, name: "Edit Avtar", field: "editavtar" },
  { _id: 6, name: "Action", field: "action" },
];

const AddIntDealershipForm = () => {
  const { apiFetcher } = useApiFetcher();
  const [dealerShipName, setdealerShipName] = useState("");
  const [avatar, setAvatar] = useState("");
  const [voice, setVoice] = useState("");
  const [query, setquery] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [Dealers, setDealers] = useState([]);
  const [isediting, setIsEditing] = useState(false);
  const [editingUserId, setEditingUserId] = useState(null);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isDebounceCompleted, setisDebounceCompleted] = useState(false);
  const [dynamicVoiceOptions, setDynamicVoiceOptions] = useState([]);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);


  const imageButtons = [
    { id: 1, src: HarryBusiness, value: ["Harry", "business", "male"] },
    { id: 2, src: HarryCasual, value: ["Harry", "casual", "male"] },
    { id: 3, src: HarryYouthful, value: ["Harry", "youthful", "male"] },
    { id: 4, src: JeffBusiness, value: ["Jeff", "business", "male"] },
    { id: 5, src: JeffFormal, value: ["Jeff", "formal", "male"] },
    {
      id: 6,
      src: LisaCasualSitting,
      value: ["Lisa", "casual-sitting", "female"],
    },
    { id: 7, src: LoriCasual, value: ["Lori", "casual", "female"] },
    { id: 8, src: LoriGraceful, value: ["Lori", "graceful", "female"] },
    { id: 9, src: LoriFormal, value: ["Lori", "formal", "female"] },
    { id: 10, src: MegFormal, value: ["Meg", "formal", "female"] },
    { id: 11, src: MegCasual, value: ["Meg", "casual", "female"] },
  ];

  const voiceOptions = {
    male: [
      { value: "en-US-AndrewMultilingualNeural", label: "Andrew" },
      { value: "en-US-BrianMultilingualNeural", label: "Brian" },
    ],
    female: [
      { value: "en-US-AvaMultilingualNeural", label: "Ava" },
      { value: "en-US-EmmaMultilingualNeural", label: "Emma" },
    ],
  };


  const fetchDealers = async () => {
    try {
      setLoading(true);
      // console.log('apiurl', API_URL)
      const response = await apiFetcher("/int-dealerships");
      console.log(response);
      setDealers(response);
      setLoading(false);
    } catch (error) {
      console.error(error.errorMessage);
      setError("An error occurred while fetching users");
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const fetchUserByname = (query) => {
    if (!query) {
      setFilteredUsers([]);
      setisDebounceCompleted(false);
      return;
    }
    const filteredNames = Dealers?.filter((user) => {
      return user?.dealershipName?.toLowerCase().includes(query.toLowerCase());
    });
    setFilteredUsers(filteredNames);
    setisDebounceCompleted(true);
  };




  useEffect(() => {
    fetchDealers();
  }, []);

  const handleSubmit = async (event) => {
    // Handle save logic
    event.preventDefault();
    setIsEditing(false);
    setEditingUserId(null);
    setdealerShipName("");
    setAvatar("");
    setVoice("");

    const url = isediting ? `/int-dealerships/${editingUserId}` : `/int-dealerships`;
    const method = isediting ? "PATCH" : "POST";
    const payload = {
      dealershipName: dealerShipName,
      avatar: avatar,
      style: avatar,
      voice,
    };

    try {
      const response = await apiFetcher(url, method, payload);
      console.log(response, "response");
      fetchDealers();
    } catch (error) {
      console.error("error failed:", error.message);
    }
  };

  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditingUserId(null);
    setdealerShipName("");
    setAvatar("");
    setVoice("");
  }

  const handleEdit = (user) => {

    if (!user?._id) {
      console.error("Invalid user object in handleEdit");
      return;
    }
    setIsEditing(true);
    setdealerShipName(user?.dealershipName || "");
    setAvatar(user?.avatar || "");
    setVoice(user?.voice || "");

    setEditingUserId(user._id);
  };



  const handleAvatarSelect = (avatarValue) => {
    let check = avatarValue.split(",");
    setAvatar(avatarValue);

    if (check.length === 3) {
      let gender = check[2].trim();
      const voiceList = voiceOptions[gender] || [];
      if (Array.isArray(voiceList)) {
        setDynamicVoiceOptions(voiceList);
      } else {
        console.error(`No voice options available for gender: ${gender}`);
        setDynamicVoiceOptions([]);
      }
    } else {
      console.error("Invalid avatar format:", avatarValue);
      setDynamicVoiceOptions([]);
    }

    setIsDropdownOpen(false);
  };

  const handleOutsideClick = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [dropdownRef]);

  const handleDelete = async (id) => {
    if (!id) {
      console.error("Invalid ID in handleDelete");
      return;
    }

    // Show confirmation popup
    const result = await Swal.fire({
      title: "",
      text: "Are you sure You want to delete this dealership?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      try {
        const response = await apiFetcher(`/int-dealerships/${id}`, "DELETE");
        console.log("Delete response:", response);
        fetchDealers(); // Refresh the list

        // Success message
        Swal.fire("Deleted!", "The item has been deleted.", "success");
      } catch (error) {
        console.error("Failed to delete user:", error.message);

        // Error message
        Swal.fire("Error", "Failed to delete the item. Please try again.", "error");
      }
    } else {
      console.log("User canceled delete operation.");
    }
  };


  const debouncedfn = useCallback(debounce(fetchUserByname, 300), [Dealers]);

  useEffect(() => {
    debouncedfn(query);
  }, [query]);

  return (
    <>
      <div className={styles.container}>
        <h2 className={styles.heading}> {isediting ? "Edit" : "Add New"} Pitch Dealership</h2>
        <form className={styles.form} onSubmit={handleSubmit}>
          <div className={styles.row}>
            <div className={styles.inputGroup}>
              <label htmlFor="dealershipname">Dealership Name</label>
              <input
                id="dealershipname"
                placeholder="Dealership Name"
                type="text"
                name="userName"
                value={dealerShipName}
                onChange={(e) => setdealerShipName(e.target.value)}
                required
                className={styles.input}
              />
            </div>

          </div>



          {/* 3rd row */}
          <div className={styles.row}>
            <div className={styles.inputGroup}>
              <label htmlFor="avatar">Avatar Selection</label>
              <div className={styles.customDropdown}>
                <div className={styles.dropdown}>
                  <button
                    type="button"
                    className={styles.dropdownButton}
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)} // Toggle dropdown visibility
                  >
                    {avatar ? (
                      <>
                        <img
                          src={
                            imageButtons.find((btn) => btn.value.join(", ") === avatar)?.src
                          }
                          alt="Selected Avatar"
                          className={styles.avatarImage}
                        />
                        {avatar}
                      </>
                    ) : (
                      <span className={styles.dropdownButtonspan}>Select Avatar</span>
                    )}
                  </button>
                  {isDropdownOpen && ( // Only show dropdown content when isDropdownOpen is true
                    <div className={styles.dropdownContent}>
                      {imageButtons.map((button) => (
                        <div
                          key={button.id}
                          className={styles.dropdownOption}
                          onClick={() =>
                            handleAvatarSelect(button.value.join(", "))
                          }
                        >
                          <img
                            src={button.src}
                            alt={button.value[0]}
                            className={styles.avatarImage1}
                          />
                          <span>{`${button.value[0]} - ${button.value[1]}`}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className={styles.inputGroup}>
              <label htmlFor="voice">Voice</label>
              <select
                id="voice"
                value={voice}
                onChange={(e) => setVoice(e.target.value)}
                name="voice"
                className={styles.input}
                required

              >
                {/* Default placeholder option */}
                <option value="" disabled className={styles.dropdownButtonspan} >
                  Select Voice
                </option>
                {dynamicVoiceOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

          </div>

          <div className={styles.buttonContainer}>

            {isediting ? (
              <button className={styles.cancelButton} onClick={handleCancelEdit}>
                Cancel
              </button>
            ) : null}

            <button type="submit" className={styles.dealsaveButton}>
              {isediting ? "Update" : "Save"}
            </button>
          </div>
        </form>
      </div>
      {loading ? (<LoaderSpiner />) :
        (
          <Table
            columns={columns}
            Dealers={Dealers}
            filteredUsers={filteredUsers}
            handleEdit={handleEdit}
            handleDelete={(id) => handleDelete(id)}
            query={query}
            setquery={setquery}
            isDebounceCompleted={isDebounceCompleted}
          />
        )}
    </>
  );
};

export default AddIntDealershipForm;